import type { FormField } from "../form-queries";

const CHANNEL_WORDS: Record<string, string> = { email: "emails", sms: "text messages" };

/**
 * The form as a visitor meets it on a page (studio design): each question with its kind of answer, the required ones
 * marked, a send button, and the thank-you message under it. It follows the questions as they are edited.
 */
export function FormPreview({
  fields,
  thankYou,
}: {
  readonly fields: readonly FormField[];
  readonly thankYou: string;
}) {
  return (
    <div className="ws-formview" aria-hidden>
      {fields.length === 0 ? (
        <p className="ws-formview__empty">Add a question to see the form here.</p>
      ) : (
        fields.map((field, i) => {
          const label = field.label.trim() === "" ? `Question ${String(i + 1)}` : field.label;
          const star =
            field.required === true ? <span className="ws-formview__star"> *</span> : null;
          if (field.type === "checkbox" || field.type === "consent") {
            return (
              <span key={`${field.key}-${String(i)}`} className="ws-formview__tick">
                <span className="ws-formview__box" />
                <span>
                  {field.type === "consent"
                    ? `${label} (${CHANNEL_WORDS[field.channel ?? "email"] ?? "messages"})`
                    : label}
                  {star}
                </span>
              </span>
            );
          }
          return (
            <span key={`${field.key}-${String(i)}`} className="ws-formview__field">
              <span className="ws-formview__label">
                {label}
                {star}
              </span>
              {field.type === "choice" ? (
                <span className="ws-formview__options">
                  {(field.options ?? []).length === 0 ? (
                    <span className="ws-formview__option">Choices appear here</span>
                  ) : (
                    (field.options ?? []).map((option) => (
                      <span key={option} className="ws-formview__option">
                        <span className="ws-formview__radio" />
                        {option}
                      </span>
                    ))
                  )}
                </span>
              ) : (
                <span
                  className="ws-formview__input"
                  data-long={field.type === "long_text" ? "" : undefined}
                >
                  {field.type === "email"
                    ? "name@example.com"
                    : field.type === "phone"
                      ? "(555) 555-0123"
                      : ""}
                </span>
              )}
            </span>
          );
        })
      )}
      <span className="ws-formview__send">Send</span>
      {thankYou.trim() === "" ? null : (
        <span className="ws-formview__thanks">After sending: “{thankYou}”</span>
      )}
    </div>
  );
}
